var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.loading)?_c('span',{staticClass:"loader",style:(`border: 2px solid ${_vm.textColor}; border-bottom-color: transparent`)}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }